export const GUTTER = 'tw:w-[30px] tw:shrink-0 tw:text-sm tw:text-gray-600'

export const ACTIONS_BOX = 'tw:flex tw:flex-col tw:gap-3 tw:bg-gray-100 tw:rounded-lg! tw:px-2 tw:py-3'

export const FRAME = 'tw:border tw:border-solid tw:border-gray-300 tw:rounded-md! tw:shrink-0'
  + ' tw:bg-white tw:overflow-hidden'

export const FRAME_HEADER = 'tw:flex tw:items-center tw:gap-3 tw:px-3 tw:py-2.5'
  + ' tw:border-b tw:border-solid tw:border-gray-300'

export const FRAME_BODY = 'tw:p-4'
